export default __webpack_public_path__ + "static/media/video_ai_tutorial.65d4b879.mp4";